export const routes = {
    "/:taskId/write-to-gp-specialist": {
        title: "Action Task"
    },
    "/:taskId/general-practitioner-specialist-letter": {
        title: "GP/Specialist Letter",
        isPdfRoute: true
    },
    "/:taskId/send-letter-to-gp-specialist": {
        title: "Send letter to GP/Specialist"
    }
};
